var burger = document.querySelector(".burger");
var menu = document.querySelector(".menu");
var burgerTitle = document.querySelector(".burger-menu-title");

// Overlay flouté
var overlay = document.createElement("div");
overlay.classList.add("menu-overlay");
document.body.appendChild(overlay);

var toggleMenu = function toggleMenu() {
  menu.classList.toggle("is-active");
  burger.classList.toggle("is-active");
  overlay.classList.toggle("is-active");
  burgerTitle.textContent = burger.classList.contains("is-active") ? "CLOSE" : "MENU";
};

burger.addEventListener("click", toggleMenu);
overlay.addEventListener("click", toggleMenu);

